import { FC, lazy, Suspense } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import ProtectedRoute from "./components/ProtectedRoute";

const AppLazy = lazy(() => import("./app"));
const PublicLazy = lazy(() => import("./public"));

const router = createBrowserRouter([
  {
    path: "/app/*",
    element: (
      <ProtectedRoute>
        <Suspense fallback={<></>}>
          <AppLazy />
        </Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: "/*",
    element: (
      <Suspense fallback={<></>}>
        <PublicLazy />
      </Suspense>
    ),
  },
]);

const RouteLayout: FC = () => {
  return <RouterProvider router={router} />;
};

export default RouteLayout;
